<template lang="">
  <div class="container">
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="企业代号" prop="code">
        <Input
          v-model="formValidate.code"
          placeholder="请输入4位数代号"
        ></Input>
      </FormItem>
      <FormItem label="企业名称" prop="name">
        <Input v-model="formValidate.name" placeholder="请输入企业名称"></Input>
      </FormItem>
      <FormItem label="负责人" prop="inCharge">
        <Input
          v-model="formValidate.inCharge"
          placeholder="请输入负责人"
        ></Input>
      </FormItem>
      <FormItem label="手机号" prop="phone">
        <Input
          v-model="formValidate.phone"
          placeholder="请输入联系号码"
        ></Input>
      </FormItem>
      <FormItem label="账号" prop="account">
        <Input v-model="formValidate.account" placeholder="请设置账号"></Input>
      </FormItem>
      <FormItem label="密码" prop="password">
        <Input v-model="formValidate.password" placeholder="请设置密码"></Input>
      </FormItem>
      <FormItem label="位数" prop="CodeLen">
        <Select v-model="formValidate.CodeLen" placeholder="请选择防伪码位数">
          <!-- <Option value="11">4+11 (最多数量900万)</Option> -->
          <Option value="12">4+12 (最多数量9亿9千万)</Option>
          <!-- <Option value="13">4+13</Option> -->
        </Select>
      </FormItem>
      <FormItem label="所属行业" prop="city">
        <Select v-model="formValidate.city" placeholder="请选择所属行业">
          <Option value="0">请选择行业</Option>
          <Option value="1">农产品</Option>
          <Option value="2">畜牧养殖</Option>
          <Option value="3">保健品</Option>
          <Option value="4">医药</Option>
          <Option value="5">医疗器械</Option>
          <Option value="6">计算机硬件</Option>
          <Option value="7">通讯产品</Option>
          <Option value="8">电子商务</Option>
          <Option value="9">食品</Option>
          <Option value="10">茶叶</Option>
          <Option value="11">酒</Option>
          <Option value="12">服饰皮具</Option>
          <Option value="13">化妆品</Option>
          <Option value="14">计算机软件</Option>
          <Option value="15">互联网</Option>
          <Option value="16">建材</Option>
          <Option value="17">饮料</Option>
          <Option value="18">防伪</Option>
          <Option value="19">印刷</Option>
          <Option value="20">母婴</Option>
          <Option value="21">汽配</Option>
        </Select>
      </FormItem>
      <FormItem label="所在地址" prop="desc">
        <Row>
          <Col span="12">
            <City v-model="formValidate.address" show-suffix />
          </Col>
        </Row>
        <Input
          v-model="formValidate.DateAddress"
          type="textarea"
          placeholder="详细地址"
        ></Input>
      </FormItem>
      <FormItem label="到期时间">
        <Row>
          <FormItem prop="date">
            <DatePicker
              type="date"
              placeholder="日期"
              v-model="formValidate.date"
            ></DatePicker>
          </FormItem>
        </Row>
      </FormItem>
      <FormItem label="模块" prop="module">
        <CheckboxGroup v-model="formValidate.module">
          <Checkbox label="防伪"></Checkbox>
          <Checkbox label="溯源"></Checkbox>
          <Checkbox label="分发"></Checkbox>
          <Checkbox label="物流"></Checkbox>
        </CheckboxGroup>
      </FormItem>
      <FormItem label="备注" prop="desc">
        <Input
          v-model="formValidate.desc"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
          placeholder="备注信息..."
        ></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit('formValidate')"
          >确认添加</Button
        >
      </FormItem>
    </Form>
  </div>
</template>
<script>
import { NewClients } from "@/api/index";
export default {
  data() {
    return {
      formValidate: {
        code: "", //企业代号
        name: "", //企业名称
        inCharge: "", //负责人
        phone: "", //负责人联系方式
        account: "", //账号
        password: "", //密码
        city: "", //行业
        CodeLen: "", //防伪位数
        module: [], //模块
        date: "", //日期
        // time: '',       //时间
        desc: "", //备注
        address: "110000",
        DateAddress: "",
        CodeLen: "",
      },
      ruleValidate: {
        code: [
          { required: true, message: "请输入企业代号", trigger: "blur" },
          {
            type: "string",
            min: 4,
            message: "企业号最少需要 4 位数",
            trigger: "blur",
          },
        ],
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        inCharge: [
          { required: true, message: "请填写负责人", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入负责人联系方式", trigger: "blur" },
        ],
        account: [
          { required: true, message: "请设置登录账号", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请设置登录密码", trigger: "blur" },
          {
            type: "string",
            min: 6,
            message: "密码最少需要 6 位数",
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: "Please select the city",
            trigger: "change",
          },
        ],
        date: [
          {
            required: true,
            type: "date",
            message: "Please select the date",
            trigger: "change",
          },
        ],
        CodeLen: [
          {
            required: true,
            type: "date",
            message: "选择防伪码位数",
            trigger: "change",
          },
        ],
        // time: [
        //     { required: true, type: 'string', message: 'Please select time', trigger: 'change' }
        // ],
      },
    };
  },
  methods: {
    NewClient() {
      NewClients({
        code: this.formValidate.code, //企业代号
        name: this.formValidate.name, //企业名称
        inCharge: this.formValidate.inCharge, //负责人
        phone: this.formValidate.phone, //负责人联系方式
        account: this.formValidate.account, //账号
        password: this.formValidate.password, //密码
        city: this.formValidate.city, //行业
        module: JSON.stringify(this.formValidate.module), //模块
        date: this.formValidate.date, //日期
        // time: this.formValidate.time,          //时间
        desc: this.formValidate.desc, //备注
        address: this.formValidate.address, //地址
        DateAddress: this.formValidate.DateAddress, //详细地址
        len: this.formValidate.CodeLen, //防伪码长度
      }).then((res) => {
        if (res.success) {
          $obj = {
            incode: this.formValidate.code,
            name: this.formValidate.name,
            account: this.formValidate.account,
            phone: this.formValidate.phone,
            incharge: this.formValidate.inCharge,
            site: this.formValidate.DateAddress,
            trade: "",
            dueDate: "",
            module: JSON.stringify(this.formValidate.module),
            desc: this.formValidate.desc,
            control: 2,
            date: this.formValidate.date,
            city: this.formValidate.city,
          };
          this.$emit("change", $obj);
          this.formValidate = {};
          this.$Message.success("添加成功");
        } else {
          this.$Notice.error({ title: res.msg });
        }
      });
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.NewClient();
          // this.$Message.success('Success!');
        } else {
          this.$Message.error("请填写完整!");
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
  },
};
</script>
<style scoped>
.container {
  width: 100%;
}
</style>
